import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { ReactNode, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './StyledTab.module.scss';
import useIsMobile from '@/componentShare/hooks/useIsMobile';

const cx = classNames.bind(styles);

export type Tab = {
  label: string;
  Panel: ReactNode;
};

type StyledTabProps = {
  tabs: Tab[];
  isFitHeight?: boolean
}

export default function StyledTab({ tabs, isFitHeight }: StyledTabProps) {
  const [tab, setTab] = useState(1);
  const matches = useIsMobile()

  const handleTabChange = (event: React.SyntheticEvent, newTab: number) => {
    setTab(newTab);
  }
  return (
    <>
      <TabContext value={tab}>
        <TabList
          variant="scrollable"
          scrollButtons={matches}
          allowScrollButtonsMobile={matches}
          onChange={handleTabChange} className={cx('tab-list')}>
          {tabs.map((tab, index) => (
            <Tab sx={{
              fontSize: '16px',
              lineHeight: '24px',
              fontWeight: '700'
            }} label={tab.label} value={index + 1} key={index} disableRipple />
          ))}
        </TabList>
        {tabs.map((tab, index) => (
          <TabPanel sx={isFitHeight === true ? { height: 'calc(100% - 90px)' } : {}} value={index + 1} key={index} className={cx('tab-panel')}>
            {tab.Panel}
          </TabPanel>
        ))}
      </TabContext>
    </>
  );
}